<template>
  <div class="pop_cupon pop_bege" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click.prevent="$modal.hide('coupon')">
            <close/>
          </a>
        </div>
        <div class="pop_frame">
          <h2 class="title25">
            <span>{{wpData.globalOptions.coupon_title}}</span>
            {{wpData.globalOptions.coupon_subtitle}}
          </h2>
          <div class="pp_cupon_img">
            <img :src="wpData.globalOptions.coupon_img">
          </div>
          <div class="text bold" v-html="wpData.globalOptions.coupon_bot_text"></div>
          <div class="bt_green ease">
            <a href="#" v-clipboard:copy="coupon" v-clipboard:success="onCopy" v-clipboard:error="onError" @click.prevent="copyCoupon">העתק קוד קופון</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Close from "../../assets/img/close.svg";
  export default {
    data() {
      return {
        wpData: wpData,
        coupon: wpData.globalOptions.coupon.post_title
      };
    },
    methods: {
      onCopy: function(e) {
        this.$modal.hide("coupon");
      },
      onError: function(e) {
        alert("Failed to copy texts");
      }
    },
    components: {
      Close
    }
  };
</script>

<style scoped>
</style>